import React from 'react';
import withLayout from '../../components/layout/index';
import FAQs from '../../components/feature/faqs';

const FAQ = () => {
    return (
        <FAQs />
    );
};

export default withLayout(FAQ, true, true, { search: false, wisList: false, notification: false, title: `FAQ'S`, back: true });
